import React, { useState, useContext, useEffect } from 'react'
import { getUserInfo } from '../services/userService'
import { useOktaAuth } from '@okta/okta-react'
import { ERR_CONECCTION_REFUSED, ERR_TITLE_USER_INFO_NOT_RECHEABLE,ERR_DESC_USER_INFO_NOT_RECHEABLE} from '../utils/errorLiterals';
import ErrorPage from '../pages/admin/errorPage';
import { isTokenExpired } from '../utils/utils';
import { datadogRum } from "@datadog/browser-rum";

export const UserContext = React.createContext(null);

export const useUserInfo = () => {
    const userCtx = useContext(UserContext);
    if (userCtx === null) {
        throw new Error('useUserInfo must be inside of UserProvider');
    }
    return userCtx;
}

export default function UserProvider({ children }) {
    const actualURL = window.location.href;
    const { authState } = useOktaAuth();
    const [userInfo, setUserInfo] = useState(undefined);
    const [connectionError, setConnectionError] = useState(false);
    const [apiError, setApiError] = useState('');
    
    useEffect(() => {
        try {     
            if (authState && authState.accessToken && !isTokenExpired(authState.accessToken.expiresAt) && !userInfo) {
                getUserInfo(authState.accessToken.accessToken)
                    .then((user) => {
                        setUserInfo(user);
                        datadogRum.setUser({
                          id: user?.userID,
                          name: user?.name,
                          email: user?.email,
                        });
                    })
                    .catch((err) => { 
                        console.error('[UserProvider] getUserInfo error:', err);
                        if(err.message && err.message.includes(ERR_CONECCTION_REFUSED)){
                            setConnectionError(true);          
                        }else{
                            const errorMsg = err ? err.toString() : 'Error';
                            setApiError(errorMsg);
                        }
                    })
            }
        } catch (error) {
            console.error('[UserProvider] unexpected error:', error);
        }
    }, [authState]);

    if (connectionError) {
        return <ErrorPage/>
    }
    
    if(apiError){
        return ErrorPage({
                    location:{
                        state: {errorTitle: ERR_TITLE_USER_INFO_NOT_RECHEABLE,
                            errorDescription: `${ERR_DESC_USER_INFO_NOT_RECHEABLE + ' ' + apiError}`, 
                            errorUrl:actualURL,
                            errorUser: userInfo? userInfo.userID : ''}
                    }})
               
    }

    return (<UserContext.Provider value={userInfo}>
        {children}
    </UserContext.Provider>)
}